import { Component } from '@angular/core';
import MessageService from '../../services/messageService';
import EnvironmentService from '../../services/environmentService';
import HttpError from '../../models/httpError';

@Component({
  selector: 'app-hello-world',
  templateUrl: './helloWorld.component.html',
  styleUrls: ['./helloWorld.component.scss'],
  providers: [MessageService, EnvironmentService]
})
export default class HelloWorldComponent {

  constructor(messageService: MessageService) {
    this.messageService = messageService;
  }

  getMessage(): void {
    this.messageService.getMessage()
      .then(message => {
        this.title = message.title;
        this.description = message.description;
        this.webApiHostName = message.webApiHostName;
        this.dataApiHostName = message.dataApiHostName;
      })
      .catch(e => {
        this.handleError(e);
      });
  }

  private handleError(error: HttpError) {
    this.error = `Server Error: Status: ${error.status} StatusText: ${error.statusText} Url: ${error.url}`;
  }

  title: string;
  description: string;
  webApiHostName: string;
  dataApiHostName: string;
  error: string;
  messageService: MessageService;
}



// WEBPACK FOOTER //
// ./src/app/helloWorld/helloWorld.component.ts